import { Breakpoints } from '@/constants/Breakpoints';

export const isLowerThan = (width: Breakpoints) => {
  return window.innerWidth < width;
};

export const isUpperThan = (width: number) => {
  return window.innerWidth > width;
};
